import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';

import { AppComponent } from './app.component';
import { TriviaCardComponent } from './trivia-card/trivia-card.component';

import { HtmlCodesPipe } from './html-codes.pipe';



@NgModule({
  declarations: [
    AppComponent,
    TriviaCardComponent,
    HtmlCodesPipe
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
